import { CommonModule, DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  inject,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CultureFacade } from '@boels/shared-state';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import {
  CountryISO,
  NgxIntlTelInputModule,
  PhoneNumberFormat,
  SearchCountryField,
} from 'ngx-intl-tel-input';
import { Subscription } from 'rxjs';
import { LimitHintComponent } from '../form/limit-hint/limit-hint.component';

@Component({
  selector: 'boels-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslocoModule,
    NgxIntlTelInputModule,
    LimitHintComponent,
  ],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['form'],
    },
  ],
})
export class PhoneComponent implements OnInit, OnDestroy, AfterViewInit {
  private cultureFacade = inject(CultureFacade);
  private renderer = inject(Renderer2);
  private document = inject<Document>(DOCUMENT);

  @ViewChild('tel_input') telInput!: ElementRef;
  @ViewChild('limit_hint') limitHint!: LimitHintComponent;

  @Input() phoneControl: FormControl;
  @Input() maxLength = 15;
  @Input() required = true;
  protected subs$: Subscription = new Subscription();

  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  activeCountryISO: CountryISO;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.Netherlands,
    CountryISO.UnitedKingdom,
  ];

  ngAfterViewInit(): void {
    const input = this.document.getElementById('phone') as HTMLInputElement;
    if (input) {
      this.renderer.listen(input, 'focus', () => this.limitHint.onFocus());
      this.renderer.listen(input, 'blur', () => this.limitHint.onBlur());
    }
  }

  ngOnInit() {
    this.getActiveBaseSite();
  }

  getActiveBaseSite(): void {
    this.subs$.add(
      this.cultureFacade.getActiveCulture().subscribe((culture) => {
        this.activeCountryISO = culture.split('-')[1] as CountryISO;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs$.unsubscribe();
  }
}
